import { useSelector } from 'react-redux';

import {
  selectDVCPMATrackingForecastChartData,
  selectDVCPMATrackingForecastChartType,
  selectDVCPMATrackingForecastSubpage,
  selectDVCPMATrackingForecastAutoQuerying,
} from 'redux/reducers/meteorologyAgroTrackingForecastDetailedViewControlPanelReducer';
import type { MeteorologyAgroTrackingForecastDetailedViewControlPanel as T } from 'redux/reducers/meteorologyAgroTrackingForecastDetailedViewControlPanelReducer';
import { ResponseError } from 'services/api/base';

export default function useChartData() {
  const subpage: T['subpage'] = useSelector(selectDVCPMATrackingForecastSubpage);
  const chartType: T['chartType'] = useSelector(selectDVCPMATrackingForecastChartType);
  const chartData: T['chartData'] = useSelector(selectDVCPMATrackingForecastChartData);
  // Auto-consulta de abertura em curso (#1822): o slot ainda não tem isFetching,
  // então o gráfico usa esta flag para manter o spinner durante toda a cascata.
  const autoQuerying: T['autoQuerying'] = useSelector(selectDVCPMATrackingForecastAutoQuerying);
  const key = `${subpage}-${chartType}`;

  const { data, error, isFetching } = chartData[subpage][chartType];

  return {
    key,
    data,
    isFetching,
    autoQuerying,
    queryError: error as ResponseError | undefined,
  };
}
